import type { Article } from "@/src/constants/articles";

export function ArticleBody({ article }: { article: Article }) {
    return (
        <div className="max-w-2xl mx-auto px-6 py-16 space-y-6">
            <p className="text-stone-500 font-light leading-relaxed text-lg italic border-b border-stone-100 pb-8">
                {article.excerpt}
            </p>
            {article.body.map((section, i) => {
                if (section.type === "heading") {
                    return (
                        <h2 key={i} className="font-serif text-2xl font-light italic text-stone-900 pt-4">
                            {section.content}
                        </h2>
                    );
                }
                if (section.type === "quote") {
                    return (
                        <blockquote key={i} className="border-l-2 border-stone-300 pl-6 py-2 my-8">
                            <p className="font-serif text-xl font-light italic text-stone-500 leading-relaxed">
                                {section.content}
                            </p>
                        </blockquote>
                    );
                }
                return (
                    <p key={i} className="text-stone-600 font-light leading-relaxed">
                        {section.content}
                    </p>
                );
            })}
        </div>
    );
}
